import React from "react";
import styled from "styled-components";
import vagasBlue from "../../assets/vagasBlue.png";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17.5px;
  background-color: #FFFEF9;
  border-bottom: 1px solid #ddd;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const CadastrarVagasText = styled.div`
  font-size: 20px; 
  color: #FF9F1F;
  font-weight: bold;
  margin-left: 0px;
`;

const TextAndButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const WelcomeText = styled.div`
  font-size: 18px; /* Tamanho padronizado */
  color: #002E3B;
  font-weight: 600;
  margin-left: 45px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const BemVindoWrapper = styled.div`
  @media (max-width: 768px) {
    padding-top: 50px;
  }
`;

const CadastroVagasHeader = () => {
  return (
    <BemVindoWrapper>
      <Container>
        <TextAndButtons>
          <WelcomeText>VAGAS</WelcomeText>
          <img src={vagasBlue} alt="Especialidades" style={{ marginLeft: "0px", width: "40px", height: "40px", marginTop: "5px" }} />
          <CadastrarVagasText><i>Cadastro de Vagas</i></CadastrarVagasText>
        </TextAndButtons>
      </Container>
    </BemVindoWrapper>
  );
};

export default CadastroVagasHeader;